import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sequences: [],
  currentSequence: null,
  enrollments: [],
  report: null,
  contactEnrollments: [],
};

const sequencesSlice = createSlice({
  name: "sequences",
  initialState,
  reducers: {
    sequences: (state, action) => {
      state.sequences = action.payload.records || [];
    },
    currentSequence: (state, action) => {
      state.currentSequence = action.payload;
    },
    enrollments: (state, action) => {
      state.enrollments = action.payload.records || [];
    },
    report: (state, action) => {
      state.report = action.payload;
    },
    contactEnrollments: (state, action) => {
      state.contactEnrollments = action.payload.records || [];
    },
  },
});

export const {
  sequences,
  currentSequence,
  enrollments,
  report,
  contactEnrollments,
} = sequencesSlice.actions;
export default sequencesSlice.reducer;
